import * as React from "react";
import { MapLibreMap } from "@mapcomponents/react-maplibre";
import "./App.css";
import Header from "./components/Header";
import "maplibre-gl/dist/maplibre-gl.css";
import NavigationTools from "./components/NavigationTools";
import Layers from "./components/Layers";
import Pages from "./components/Pages";
import LayerSettingsButton from "./components/LayerSettingsButton/LayerSettingsButton";

function App() {
    
  const backgroundAttribution =
    "© OpenStreetMap-Mitwirkende © Europäische Union, enthält Copernicus Sentinel-2 Daten 2021, verarbeitet durch das Bundesamt für Kartographie und Geodäsie (BKG)";
  return (
    <>
      <Header />
      <MapLibreMap
        mapId="map_1"
        options={{
          zoom: 6,
          minZoom: 6,
          style: {
            glyphs:
              "https://wms.wheregroup.com/tileserver/fonts/{fontstack}/{range}.pbf",
            version: 8,
            name: "blank",
            center: [0, 0],
            zoom: 0,
            sources: {},
            layers: [
              {
                id: "background",
                type: "background",
                paint: {
                  "background-color": "rgba(0,0,0,0)",
                },
              },
            ],
          },
          center: [10.451526, 51.165691],
          attributionControl: true,
          customAttribution: backgroundAttribution,
        }}
      />
      <Layers />
      <NavigationTools />
      <LayerSettingsButton />
      <Pages />
    </>
  );
}

export default App;
